export const environment = {
  production: false,
  TENANT_ID:
    'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef',
  CLIENT_ID: '9d822665-267a-4ec4-83e5-f1002b928b0e',
  REDIRECT_URL: 'https://dev.subprod.newlios.toyota.com',
  log_level: 'debug',
  ADMIN_DS_URI: 'https://dev.api.subprod.newlios.toyota.com/admin/graphql',
  APM_DS_URI: 'https://api.sit.lios.toyota.com/apm/graphql',
  BILLING_DS_URI: 'https://dev.api.subprod.newlios.toyota.com/billing/graphql',
  TLMS_SEND: 'https://ts.portal.toyotasupplier.com/lios/tlmssend',
  manifest: {
    admin: 'https://dev.admin.subprod.newlios.toyota.com/remoteEntry.js',
    apm: 'https://dev.apm.subprod.newlios.toyota.com/remoteEntry.js',
    bm: 'https://dev.bm.subprod.newlios.toyota.com/remoteEntry.js',
    lcm: 'https://dev.lcm.subprod.newlios.toyota.com/remoteEntry.js',
    cm: 'https://dev.cm.subprod.newlios.toyota.com/remoteEntry.js',
    maintenance: 'https://dev.maintenance.subprod.newlios.toyota.com/remoteEntry.js',
  },
};
